module.exports = __webpack_public_path__ + "static/media/JavaScript and jQuery.e32b2859.pdf";